import React from 'react'
import { HiOutlineHome } from 'react-icons/hi';

const HeadingArea = ({message1, message2}) => {
  return (
    <>
              <p className='fw-semibold bg-white py-3 px-4 rounded-3 fm-poppins border'>
          {message1} 
          <span className='fw-normal'>
            {' '}|{' '}<HiOutlineHome size={20} /> - {message2}
          </span>
        </p>

    </>
  )
}

export default HeadingArea
